import { render } from "./SearchBox.vue?vue&type=template&id=2fddb5ed&scoped=true&ts=true"
import script from "./SearchBox.vue?vue&type=script&lang=ts"
export * from "./SearchBox.vue?vue&type=script&lang=ts"

import "./SearchBox.vue?vue&type=style&index=0&id=2fddb5ed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fddb5ed"]])

export default __exports__